export default __webpack_public_path__ + "static/media/promo_05.c6d75880.jpg";